/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-cart-items';

export const EntityCartItemApi = {
  find: async (option: FindOptions) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any, option: CreateCartItemAbleOption) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.post(url, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (body: any) => {
    const url = pathname;
    try {
      const response = await entityService.delete(url, { data: body });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export interface CreateCartItemAbleOption {
  entityID: string;
  type: number;
}
